import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import Loading from '@/components/common/Loading';
import dynamic from 'next/dynamic';
import FruitsVegetableStore from '@/components/outlet/FruitsVegetableStore';


const fruitsVegetableStore = () => {
  return (
    <>
      <Head>
        <title>Fruits and Vegetable Billing Software with Barcode Scanning</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/fruits-vegetable-store" />
        <link rel="alternate" href="https://queuebuster.co/outlet/fruits-vegetable-store" hrefLang="en-us" />
        <meta name="description" content="QueueBuster POS streamlines billing, barcode scanning, and inventory for fruits and vegetable stores, helping both small and large businesses improve accuracy and efficiency." />
        <meta property="og:title" content="QueueBuster POS for Fruits & Vegetable Stores: Streamline Billing & Inventory" />
        <meta property="og:description" content="QueueBuster Fruits & Vegetable POS offers seamless billing with barcode scanning and easy inventory management. Designed for grocery stores and supermarkets, it optimizes processes, ensures accuracy, and keeps your fruits and vegetable business running smoothly." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/fruits-vegetable-store" />
      </Head>
         <SchemaTags page="fruits-vegetable-store" />
      <FruitsVegetableStore />
    </>
  )
}

export default fruitsVegetableStore